import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import $ from "jquery";
import BuyOrder from "./BuyOrder";
import SellOrder from "./SellOrder";
import { toast, Toaster } from "react-hot-toast";
import axios from "axios";
import * as myConstList from "../../../BaseUrl";
import jwt_decode from "jwt-decode";
import setAuthToken from "../../../utils/setAuthToken";
import { setCurrentUser } from "../../../../src/actions/authActions";
const config = {
  headers: {
    Authorization: "Bearer " + `${localStorage.getItem("jwtToken")}`,
  },
};
const toastStyles = {
  style: {
    borderRadius: "10px",
    background: "#fff",
    color: "#000",
  },
};

const baseUrl = myConstList.baseUrl;
class OrderSection extends React.Component {
  constructor(props) {
    super(props);
    const { user } = this.props.auth;
    this.state = {
      records: [],
      errors: {},
      usdt: this.props.virtualFund,
      CurrencyValue: 0,
      currentprice: this.props.currentprice,
      message: "",
      contestName: "",
      pair_idArr: [],
      pairSectionFlag: "1",
      urltemp:
        "?source=" +
        localStorage.getItem("source") +
        "&theme=" +
        localStorage.getItem("theme"),
    };
  }
  componentWillReceiveProps(nextProps) {
    // console.log("nextProps====",nextProps);
    if (nextProps.pairs.length > 0) {
      this.setState({ pair_idArr: nextProps.pairs });
    }
    if (nextProps.getCurrencyValueData) {
      if (nextProps.getCurrencyValueData) {
        // console.log("nextProps======",nextProps.getCurrencyValueData)
        this.setState({
          CurrencyValue: nextProps.getCurrencyValueData.totalcurrency,
        });
      }
    }

    if (nextProps.record) {
      this.setState({
        records: nextProps.record,
      });
    }
    if (nextProps.currentprice) {
      // console.log("nextProps.currentprice=",nextProps.currentprice);
      this.setState({
        currentprice: nextProps.currentprice,
      });
    }
    if (nextProps.contestName != undefined) {
      this.setState({
        contestName: nextProps.contestName,
      });
    }
    if (nextProps.virtualFund != undefined) {
      this.setState({
        usdt: nextProps.virtualFund,
      });
    }
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
    if (nextProps.errors.message) {
      toast.error(nextProps.errors.message, toastStyles);
      nextProps.errors.message = "";
    }
    if (
      nextProps.orderdata !== undefined &&
      nextProps.orderdata.order !== undefined &&
      nextProps.orderdata.order.data !== undefined &&
      nextProps.orderdata.order.data.message !== undefined &&
      nextProps.orderdata.order.data.status
    ) {
      this.setState({
        // message:nextProps.orderdata.order.data.message,
        btotal: "",
        bamount: "",
        stopLoss: "",
      });
    }
  }
  componentDidMount() {
    console.log(this.state, "props");
    /*setInterval(() => {
            this.getData2();
        }, 4000);*/
    //this.getCurrencyValue();
  }

  // getCurrencyValue=()=>{
  //     const { user } = this.props.auth;
  //     axios
  //             .post(baseUrl+"api/getCurrencyValue", {user_id: user.id, contestId: this.props.match.params.id, symbol: this.props.match.params.symbol },config)
  //             .then(res => {
  //                 console.log("aaaaa",res);
  //                 if (res.data[0]) {
  //                     this.setState({ CurrencyValue: res.data[0].totalcurrency })
  //                     var classThis = this;
  //                     setTimeout(function() { classThis.getCurrencyValue(); },1000);
  //                 }
  //             })
  //             .catch()
  // }

  showChatHtml = () => {
    const html = [];
    let classThis = this;
    const url = window.location.href;
    var lastSegment1 = url.split("/").pop();
    var lastSegment2 = lastSegment1.split("?");
    var lastSegment = lastSegment2[0];
    // this.state({lastSegmentValue:lastSegment});
    // console.log("this.state.pair_idArrthis.state.pair_idArr=",lastSegment);
    this.state.pair_idArr.map(function (value, i) {
      if (value.name !== null) {
        html.push(
          <>
            <li>
              <a
                href={
                  "/exchange/" +
                  classThis.props.match.params.id +
                  "/" +
                  classThis.props.match.params.exchangetype +
                  "/" +
                  value.name +
                  "-USDT" +
                  classThis.state.urltemp
                }
                style={{
                  color:
                    lastSegment.replace("-", "") == value.name + "USDT"
                      ? "#dbb747"
                      : "",
                }}
              >
                {value.name}
              </a>
            </li>
          </>
        );
      }
      // <ul>
      //                 <li>Lorem ipsum dolor sit amet</li>
      //                 <li>Lorem ipsum dolor sit amet</li>
      //                 <li>Lorem ipsum dolor sit amet</li>
      //             </ul>
    });
    return html;
  };
  getData2() {
    /*const { user } = this.props.auth;
    axios
            .post(baseUrl+"api/getCurrencyValue", {user_id: user.id, contestId: this.props.match.params.id, symbol: this.props.match.params.symbol },config)
            .then(res => {
                if (res.data[0]) {
                    this.setState({ CurrencyValue: res.data[0].totalcurrency })
                }
            })
            .catch()*/
    // axios
    // .post(baseUrl+"api/participateById", { contest_id: this.props.match.params.id, user_id: user.id })
    // .then(res => {
    //     this.setState({ usdt: res.data.virtualFund })
    // })
    // .catch()
  }

  render() {
    if (this.state.currentprice) {
      var cprice = this.state.currentprice;
    }
    const { errors } = this.state;
    const { user } = this.props.auth;

    const url = window.location.href;
    var lastSegment1 = url.split("/").pop();
    var lastSegment2 = lastSegment1.split("?");
    var lastSegment = lastSegment2[0];
    return (
      <div className="crypt-market-status mt-2">
        <div className="dashbord_hadding dropdown w_none">
          <h6 className="d-flex mb-0 text-uppercase font-weight-bold">
            Select Coin Pair
            <span
              type="button"
              className=" dropdown-toggle ml-auto"
              data-toggle="collapse"
              data-target="#Pair"
            >
              {lastSegment}
            </span>
          </h6>

          <div id="Pair" className="collapse pair-list">
            <ul>
              {this.showChatHtml()}
              {/* <li>Lorem ipsum dolor sit amet</li>
                    <li>Lorem ipsum dolor sit amet</li>
                    <li>Lorem ipsum dolor sit amet</li> */}
            </ul>
          </div>
        </div>

        <div className="crypt-boxed-area">
          <ul className="w_none nav nav-tabs" id="crypt-tab">
            <li>
              <a className="active pl-4 pr-4" data-toggle="tab" href="#buy_tab">
                Buy
              </a>
            </li>
            <li>
              <a className="pl-4 pr-4" data-toggle="tab" href="#sell_tab">
                Sell
              </a>
            </li>
          </ul>

          <div className="row no-gutters tab-content">
            <BuyOrder
              usdt={this.state.usdt}
              currentprice={cprice}
              contestName={this.state.contestName}
            />
            <SellOrder
              CurrencyValue={this.state.CurrencyValue}
              currentprice={cprice}
              contestName={this.state.contestName}
            />
          </div>
        </div>
        <Toaster position="bottom-right" reverseOrder={false} />
      </div>
    );
  }
}

OrderSection.propTypes = {
  auth: PropTypes.object.isRequired,
  orderdata: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  orderdata: state.orderdata,
  errors: state.errors,
});
export default connect(mapStateToProps)(withRouter(OrderSection));
